import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { Questionnaire } from '@shared/questionnaire/questionnaire';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireApi extends BaseApi<Questionnaire> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'questionnaire/questionnaires');
  }

  create(): Questionnaire {
    return new Questionnaire();
  }

  nameValid(uuid: string, name: string): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.endpoint}/${uuid ? uuid : ''}/validate-name?name=${name}`, {});
  }

  importMetadata(uuid: string, file: File): Observable<void> {
    const form = new FormData();
    form.append('file', file);

    return this.httpClient.post<void>(`${this.endpoint}/${uuid}/import/metadata`, form);
  }
}
